<template>
    <div style="margin: 20px 0 30px">
        <el-table :data="data" size="small" class="ah-el-data-table no-bottom-border row-click" @row-click="$event => $emit('row-click', $event)">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="類型" width="85">請款單</el-table-column>
            <el-table-column label="單號" prop="payoo" width="140">
                <template slot-scope="scope">
                    <span>{{ scope.row.payoo }}</span>
                </template>
            </el-table-column>
            <el-table-column label="類型" prop="paymentType" width="140">
                <template slot-scope="scope">
                    <span class="idx">
                        {{ getPaymentTypeName(scope.row.paymentType) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="摘要" prop="payoo">
                <template slot-scope="scope">
                    <span v-if="scope.row.paymentType == 4">{{ scope.row.ofeN_ITEM_NAME }}</span>
                    <span v-else class="">{{ scope.row.nam }}</span>
                </template>
            </el-table-column>
            <el-table-column label="收款人" prop="vdR_NAM" align="right" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.vdR_NAM }}</span>
                </template>
            </el-table-column>
            <el-table-column label="帳款金額" prop="amt" align="right" width="120">
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" />
                </template>
            </el-table-column>
            <el-table-column label="實付金額" prop="actuallAmt" align="right" width="120">
                <template slot-scope="scope">
                    <Money :v="scope.row.actuallyAmt" />
                </template>
            </el-table-column>
            <el-table-column label="幣別" prop="cny" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.cny }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        getPaymentTypeName: {
            type: Function,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
